import { APP_ID, GATEWAY_BASE } from './config';

// AQUASTAR-369 — per-environment app links from the gateway (admin-managed).
export interface AppLinks {
  iosStoreUrl: string | null;
  androidStoreUrl: string | null;
}

let cached: AppLinks | null = null;
let inflight: Promise<AppLinks> | null = null;

export async function fetchAppLinks(): Promise<AppLinks> {
  if (cached) return cached;
  if (!inflight) {
    inflight = fetch(`${GATEWAY_BASE}/v1/app/${APP_ID}/links`)
      .then(async (r) => {
        if (!r.ok) throw new Error(`links ${r.status}`);
        const j = (await r.json()) as { links?: Partial<AppLinks> };
        const l: AppLinks = {
          iosStoreUrl: typeof j.links?.iosStoreUrl === 'string' ? j.links.iosStoreUrl : null,
          androidStoreUrl: typeof j.links?.androidStoreUrl === 'string' ? j.links.androidStoreUrl : null,
        };
        cached = l;
        return l;
      })
      .catch(() => ({ iosStoreUrl: null, androidStoreUrl: null }))
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

export function peekAppLinks(): AppLinks | null {
  return cached;
}

/** Test seam. */
export function _resetAppLinksCache() {
  cached = null;
  inflight = null;
}

